import React from 'react';
import {connect} from 'react-redux';
import {printRoute} from '../../../constants/public-routes';

const PrintDirectly = (props) => {
  let {intl, ids, disabled} = props;
  return (<a style={{display: disabled ? 'none' : null}} href={printRoute(intl.locale, ids, [])} target="_blank">
    <span className="badge">
      <i className="glyphicon glyphicon-print" title={intl.messages.print}></i>
    </span>
  </a>);
};

PrintDirectly.propTypes = {
  ids: React.PropTypes.array.isRequired,
  intl: React.PropTypes.object,
  disabled: React.PropTypes.bool
};

PrintDirectly.defaultProps = {
  disabled: false
};

function mapStateToProps(state) {
  const {intl} = state;
  return {
    intl
  };
}

export default connect(mapStateToProps)(PrintDirectly);



/** WEBPACK FOOTER **
 ** ./src/modules/print/containers/PrintDirectly.js
 **/